import { render, staticRenderFns } from "./VotingClosed.vue?vue&type=template&id=dc0ea6a4&scoped=true&"
import script from "./VotingClosed.vue?vue&type=script&lang=js&"
export * from "./VotingClosed.vue?vue&type=script&lang=js&"
import style0 from "./VotingClosed.vue?vue&type=style&index=0&id=dc0ea6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0ea6a4",
  null
  
)

export default component.exports